import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import { LangProvider } from "./context/LangContext";

// Map friendly URL paths to section IDs on the single-page site
const ROUTE_TO_SECTION = {
  "/": "hero",
  "/despre": "about",
  "/about": "about",
  "/preturi": "pricing",
  "/pricing": "pricing",
  "/acte": "docs",
  "/acte-necesare": "docs",
  "/documents": "docs",
  "/galerie": "gallery",
  "/gallery": "gallery",
  "/testimoniale": "testimonials",
  "/testimonials": "testimonials",
  "/faq": "faq",
  "/intrebari": "faq",
  "/contact": "contact",
  "/programare": "contact",
};

// Hoisted to avoid creating a new object on every render
const TOAST_OPTIONS = {
  classNames: { toast: "!rounded-2xl !border-brand-border-soft" },
};

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          {Object.entries(ROUTE_TO_SECTION).map(([path, section]) => (
            <Route key={path} path={path} element={<HomePage scrollTo={section} />} />
          ))}
          <Route path="*" element={<HomePage scrollTo="hero" />} />
        </Routes>
        <Toaster
          position="top-right"
          richColors
          toastOptions={TOAST_OPTIONS}
        />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
